import { createTheme } from '@mui/material/styles'
import darkScrollbar from '@mui/material/darkScrollbar'
import base from './base'

const theme = createTheme(base, {
    id: 'elogbook',
    name: 'elogbook',
    logo: 'elbLogo.svg',
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: darkScrollbar(),
            },
        },
    },
});
export default theme
